import React, { useState } from 'react';
import { Icon, Input, Tag } from 'antd';

interface InputTagProps extends React.Props<null> {
  onAdd: (tag: string) => void;
  style?: any;
}

export function InputTag(props: InputTagProps) {
  const [isInputState, setIsInputState] = useState(false);

  return isInputState ? (
    <Input
      autoFocus={true}
      type="text"
      size="small"
      style={{ width: 78, borderColor: alo7Theme.primaryColor, ...props.style }}
      defaultValue={''}
      onBlur={e => {
        if (e.target.value) {
          props.onAdd(e.target.value);
        }
        setIsInputState(false);
      }}
      onPressEnter={e => {
        if (e.currentTarget.value) {
          props.onAdd(e.currentTarget.value);
        }
        setIsInputState(false);
      }}
    />
  ) : (
    <Tag
      onClick={() => setIsInputState(true)}
      style={{ background: '#fff', borderStyle: 'dashed', ...props.style }}>
      <Icon type="plus" /> 标签
    </Tag>
  );
}
